import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(consent-manger)/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(consent-manger)/StoreProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionTokenSync"] */ "/app/src/components/auth/SessionTokenSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseAuthProvider"] */ "/app/src/components/auth/SupabaseAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FrontendWatchdog"] */ "/app/src/components/FrontendWatchdog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GTMGuarded"] */ "/app/src/components/GTMGuarded.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider","ThemeSync"] */ "/app/src/components/theme/ThemeProvider.tsx");
